import * as React from "react";
import {useEffect} from "react";
import {Link} from "react-router-dom";
import {ConstColor} from "src/config/styles_const/styles_const";
import {Multi_SkillTag} from "src/domain/model/skill_tag";
import {ICustomerRepository} from "src/domain/repository/customer_repository";
import {createCustomerAPI} from "src/infra/api/service/customer_api";
import styled from "styled-components";
import {routeConfig} from "../../../../config/language/ja-JP/presentation/route_text";
import {Customer} from "../../../../domain/model/customer";
import {JobCareer} from "../../../../domain/model/job_career";
import {PastCaseProject} from "../../../../domain/model/past_case_project";
import {IMultiSkillTagRepository} from "../../../../domain/repository/skill_tag_repository";
import {createApiClient, IApiClient} from "../../../../infra/api/client";
import {entity} from "../../../../infra/api/rpc/api";
import {createMultiSkillTagAPI} from "../../../../infra/api/service/skill_tag_api";
import PageWrapper from "../../../common/atom/wrapper/page_wrapper";
import Breadcrumbs from "../../../common/molecular/breadcrumbs/breadcrumbs";
import Progress from "../../../common/organism/progress";
import {TBreadcrumbItem} from "../../../type/common";
import JobCareerEditForm from "./edit/job_career_edit_form";

const apiClient: IApiClient = createApiClient();
const multiSkillTagRepository: IMultiSkillTagRepository =
    createMultiSkillTagAPI(apiClient);
const customerRepository: ICustomerRepository = createCustomerAPI(apiClient);

interface IProps {
    isLoading: boolean;
    customer: Customer | null;
    jobCareers: JobCareer[];
    pastCaseProjects: PastCaseProject[];
    handleUpdateCustomerSubmit: (values: any) => void;
}

const openAICareerNum = 2;

const JobCareerEditComponent: React.FC<IProps> = (props) => {
    const {
        isLoading,
        customer,
        jobCareers,
        pastCaseProjects,
        handleUpdateCustomerSubmit,
    } = props;

    const [tags, setTags] = React.useState<entity.IMultiSkillTag[]>([]);
    const [genDutySummaryModal, setGenDutySummaryModal] =
        React.useState<boolean>(false);
    const [generatedDutySummary, setGeneratedDutySummary] = React.useState<
        string | undefined
    >();
    const [selectedDutySummary, setSelectedDutySummary] = React.useState<
        string | undefined
    >();

    const breadcrumbItems: TBreadcrumbItem[] = [
        routeConfig.customerRoot,
        routeConfig.customerMypage,
        routeConfig.customerMypageEdit,
    ];

    useEffect(() => {
        window.addEventListener("beforeunload", onUnload);
        return () => {
            window.removeEventListener("beforeunload", onUnload);
        };
    });

    useEffect(() => {
        try {
            multiSkillTagRepository.getAll(1, 10000).then((items) => {
                setTags(items || []);
            });
        } catch (e) {

        }
    }, []);

    const onUnload = (e: any) => {
        e.preventDefault();
        e.returnValue = "";
    };

    return (
        <div>
            {isLoading && <Progress canAnimation={false}/>}

            <PageWrapper>
                <div style={{maxWidth: 600, margin: "0 auto"}}>
                    <Breadcrumbs breadcrumbItems={breadcrumbItems}/>
                    <JobCareerEditForm
                        // For Redux-Form
                        initialValues={{
                            customer,
                            jobCareers,
                            pastCaseProjects,
                            tags_1: customer!.multiSkillTags
                                .filter(
                                    (v) =>
                                        v.category ===
                                        Multi_SkillTag.Category.Category_IntroductionOperation
                                )
                                .map((v) => v.id),
                            tags_7: customer!.multiSkillTags
                                .filter(
                                    (v) =>
                                        v.category ===
                                        Multi_SkillTag.Category.Category_PersonalConnections
                                )
                                .map((v) => v.id),
                            tags_5: customer!.multiSkillTags
                                .filter(
                                    (v) =>
                                        v.category ===
                                        Multi_SkillTag.Category.Category_DevelopFramework
                                )
                                .map((v) => v.id),
                            tags_3: customer!.multiSkillTags
                                .filter(
                                    (v) =>
                                        v.category ===
                                        Multi_SkillTag.Category.Category_OverseasExpansion
                                )
                                .map((v) => v.id),
                            tags_4: customer!.multiSkillTags
                                .filter(
                                    (v) =>
                                        v.category === Multi_SkillTag.Category.Category_Programming
                                )
                                .map((v) => v.id),
                            tags_6: customer!.multiSkillTags
                                .filter(
                                    (v) => v.category === Multi_SkillTag.Category.Category_AI
                                )
                                .map((v) => v.id),
                        }}
                        formValues={undefined}
                        onSubmit={handleUpdateCustomerSubmit}
                        enableReinitialize={true}
                        tags={tags}
                        onGenerateDutySummary={() => {
                            setGenDutySummaryModal(true);
                            if (jobCareers.length >= openAICareerNum) {
                                customerRepository.generateDutySummary().then((res) => {
                                    setGeneratedDutySummary(res);
                                });
                            }
                        }}
                        generatedDutySummary={selectedDutySummary}
                    />
                    {genDutySummaryModal && (
                        <OpenAIModal>
                            <OpenAIModalOuter>
                                <OpenAIModalInner>
                                    <OpenAIModalTitle>
                                        <OpenAIModalTitleBadge>新機能</OpenAIModalTitleBadge>
                                        <OpenAIModalTitleText>
                                            生成AIで職務要約の下書きを作成
                                        </OpenAIModalTitleText>
                                    </OpenAIModalTitle>

                                    <OpenAIModalDesc>
                                        ✅ 入力されている職歴情報をもとに、職務要約を作成します
                                        <br/>
                                        ✅ 作成には30~60秒ほど時間がかかります
                                        <br/>✅
                                        反映するボタンをクリックすると、元の職務要約が書き換わりますのでご注意ください。
                                    </OpenAIModalDesc>

                                    {jobCareers.length >= openAICareerNum && (
                                        <OpenAIModalInput isActive={!!generatedDutySummary}>
                                            {!generatedDutySummary && (
                                                <>
                                                    <Indicator/>
                                                </>
                                            )}
                                            {generatedDutySummary && (
                                                <textarea
                                                    style={{
                                                        lineHeight: "24px",
                                                        fontSize: 16,
                                                        color: "black",
                                                        textAlign: "left",
                                                        height: 250,
                                                        width: 900,
                                                        overflowY: "scroll",
                                                        resize: "none",
                                                    }}
                                                    value={generatedDutySummary}
                                                    onChange={(e) => {
                                                        setGeneratedDutySummary(e.target.value);
                                                    }}
                                                />
                                            )}
                                        </OpenAIModalInput>
                                    )}
                                    {jobCareers.length < openAICareerNum && (
                                        <OpenAIModalAlert>
                                            <div style={{fontSize: 24, fontWeight: "bold"}}>
                                                職歴の入力が不足しています
                                            </div>
                                            <div
                                                style={{
                                                    fontSize: 12,
                                                    fontWeight: "bold",
                                                    marginTop: 20,
                                                }}
                                            >
                                                最低{openAICareerNum}
                                                つ以上の職歴情報をご入力いただき、再度こちらの機能をご利用ください。
                                            </div>
                                        </OpenAIModalAlert>
                                    )}

                                    <OpenAIModalButtons>
                                        <OpenAIModalCancelButton
                                            onClick={() => {
                                                setGeneratedDutySummary(undefined);
                                                setSelectedDutySummary(undefined);
                                                setGenDutySummaryModal(false);
                                            }}
                                        >
                                            キャンセル
                                        </OpenAIModalCancelButton>

                                        {jobCareers.length >= openAICareerNum && (
                                            <OpenAIModalDoneButton
                                                isActive={!!generatedDutySummary}
                                                onClick={() => {
                                                    if (!generatedDutySummary) {
                                                        return;
                                                    }
                                                    setGenDutySummaryModal(false);
                                                    setSelectedDutySummary(generatedDutySummary);
                                                    setGeneratedDutySummary(undefined);
                                                }}
                                            >
                                                反映する
                                            </OpenAIModalDoneButton>
                                        )}

                                        {jobCareers.length < openAICareerNum && (
                                            <JobCareerLink
                                                to={"/customer/mypage/customer/_edit_job_career"}
                                            >
                                                職歴を入力する
                                            </JobCareerLink>
                                        )}
                                    </OpenAIModalButtons>
                                </OpenAIModalInner>
                            </OpenAIModalOuter>
                        </OpenAIModal>
                    )}
                </div>
            </PageWrapper>
        </div>
    );
};

export default JobCareerEditComponent;

const OpenAIModal = styled.div`
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`;

const OpenAIModalOuter = styled.div`
    width: 1000px;
    border: 0.5px black solid;
    border-radius: 3px;
    box-shadow: 0 8px 8px 0 rgba(0, 0, 0, 0.05);
    background-color: white;
`;

const OpenAIModalInner = styled.div`
    margin: 16px;
    text-align: center;
    vertical-align: middle;
    padding: 30px;
`;

const OpenAIModalTitle = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;
const OpenAIModalTitleText = styled.div`
    display: inline-block;
    font-size: 20px;
    font-weight: bold;
`;
const OpenAIModalTitleBadge = styled.div`
    display: inline-block;
    display: inline-block;
    padding: 2px 4px;
    background-color: #00d58e;
    border-radius: 4px;
    color: white;
    font-size: 10px;
    font-weight: bold;
    margin-right: 15px;
`;

const OpenAIModalDesc = styled.div`
    width: 700px;
    margin: 0 auto;
    margin-top: 25px;
    margin-bottom: 25px;
    font-size: 16px;
    font-weight: normal;
    text-align: left;
    line-height: 25px;
`;

interface OpenAIModalInputProps {
    isActive: boolean;
}

const OpenAIModalInput = styled.div<OpenAIModalInputProps>`
    margin-top: 25px;
    margin-bottom: 25px;
    background-color: ${(props) => (props.isActive ? "white" : "#c4c4c4")};
    height: 250px;
    width: 900px;
    overflow-y: scroll;
`;

const OpenAIModalAlert = styled.div`
    margin-top: 25px;
    margin-bottom: 25px;
    border: 1px solid #d6d6d6;
    background-color: rgba(206, 65, 65, 0.2);
    height: 250px;
    width: 900px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

const OpenAIModalButtons = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
`;

const OpenAIModalCancelButton = styled.div`
    padding: 10px 20px;
    border: 1px solid #d6d6d6;
    border-radius: 4px;
    margin-right: 15px;
    background-color: white;
    color: black;
    font-size: 12px;
    cursor: pointer;
`;

interface OpenAIModalDoneButtonProps {
    isActive: boolean;
}

const OpenAIModalDoneButton = styled.div<OpenAIModalDoneButtonProps>`
    padding: 10px 20px;
    border: 1px solid #d6d6d6;
    border-radius: 4px;
    background-color: ${(props) =>
            props.isActive ? ConstColor.Corporate : "#d6d6d6"};
    color: white;
    font-size: 12px;
    cursor: pointer;
`;

const JobCareerLink = styled(Link)`
    padding: 10px 20px;
    color: white;
    font-size: 12px;
    cursor: pointer;
    background-color: ${ConstColor.Corporate};
`;

const Indicator = styled.div`
    width: 30px; /*ローディングアイコンの横サイズ*/
    height: 30px; /*ローディングアイコンの縦サイズ*/
    margin: 0 auto;
    margin-top: 100px;
    margin-bottom: 20px;
    border-radius: 50%; /*CSS3で円を書く*/
    border: 4px solid ${ConstColor.Corporate}; /*円に○の枠をつける*/
    border-right-color: transparent; /*円の右にC状の空きをつける*/
    animation: spin 1s linear infinite; /*1秒毎にくるくる回転するアニメーション*/
    @keyframes spin {
        /*0%の時は20％の透明度*/
        0% {
            transform: rotate(0deg);
            opacity: 0.2;
        }

        /*50%の時は透明度なし*/
        50% {
            transform: rotate(180deg);
            opacity: 1;
        }

        /*100%の時に20％の透明度に戻る*/
        100% {
            transform: rotate(360deg);
            opacity: 0.2;
        }
    }
`;



// WEBPACK FOOTER //
// ./src/presentation/component/customer/mypage/job_career_edit.tsx